import { camelCase, upperFirst } from 'lodash';

export default function camelizePath(path, useNerdCaps = true) {
  let camelizedPath = camelCase(path.map(part => part.split('/')[0]).join('_'));

  if (useNerdCaps) {
    camelizedPath = upperFirst(camelizedPath);
  }

  return camelizedPath;
}
